

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import AnonJobWorkerInterviewWorkerConfirmationReply from '@/models/AnonJobWorkers/AnonJobWorkerInterviewWorkerConfirmationReply';
import PageNames from '@/router/PageNames';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'WorkerInterviewConfirmationConfirmDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public request: AnonJobWorkerInterviewWorkerConfirmationReply = new AnonJobWorkerInterviewWorkerConfirmationReply();

  get allowDeclineInterview () {
      return WorkerAnonModule.interviewConfirmation.allowDeclineInterview;
  }

  get interviewConfirmation() {
    return WorkerAnonModule.interviewConfirmation;
  }

  get buttonLabel() {
    if (this.allowDeclineInterview) {
      return "CONFIRM/DECLINE";
    } else {
      return "CONFIRM";
    }    
  }

  get dialogTitle() {
    if (this.allowDeclineInterview) {
      return "Confirm or Decline Interview";
    } else {
      return "Confirm Interview";
    }    
  }

  get submitButtonLabel() {
    if (this.allowDeclineInterview) {
      return "SUBMIT";
    } else {
      return "CONFIRM";
    }   
  }
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (!this.allowDeclineInterview) {
        //Automatically tick the hidden tickbox
        this.request.confirmed = true;
      }
    }
  }

  get loading() {
    return WorkerAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.jobWorkerInterviewWorkerDeclinedReasons();
  }


	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await WorkerAnonModule.interviewWorkerConfirmation(this.request);
    this.dialog = false;
    if (WorkerAnonModule.isError) {
       this.$router.push({ name: PageNames.WorkerError });
    }
  }
}
